module.exports = __webpack_public_path__ + "img/app-pzzh.4adf77ca.png";